import { fetchData } from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";

export interface PhysicalGroupsData {
    current_group_1: number | null;
    current_group_2: number | null;
    current_group_3: number | null;
    current_group_4: number | null;
    current_not_allowed: number | null;
}

export interface HealthGroupsData {
    current_group_1: number | null;
    current_group_2: number | null;
    current_group_3: number | null;
    current_group_4: number | null;
    current_group_5: number | null;
}

export interface RehabilitationData {
    treatment_ambulatory: number | null;
    treatment_stationary: number | null;
    rehabilitation_ambulatory: number | null;
    rehabilitation_remote: number | null;
    sanatorium: number | null;
}

export interface ChildCountData {
    age_0_4_plan: number | null;
    age_0_4_fact: number | null;
    age_5_9_plan: number | null;
    age_5_9_fact: number | null;
    age_10_14_plan: number | null;
    age_10_14_fact: number | null;
    age_15_17_plan: number | null;
    age_15_17_fact: number | null;
    age_0_14_plan: number | null;
    age_0_14_fact: number | null;
    age_0_17_plan: number | null;
    age_0_17_fact: number | null;
    disabled_0_17_plan: number | null;
    disabled_0_17_fact: number | null;
}

export interface MetricsData {
    all_children_plan: number | null;
    all_children_fact: number | null;
    disabled_children_plan: number | null;
    disabled_children_fact: number | null;
    diseases_total: number | null;
    diseases_first: number | null;
}

export interface SectorChartsData {
    physicalGroups: PhysicalGroupsData | null;
    healthGroups: HealthGroupsData | null;
    rehabilitation: RehabilitationData | null;
    childCount: ChildCountData | null;
    metrics: MetricsData | null;
}

export interface SectorChartsResponse {
    success: boolean;
    data: SectorChartsData;
    message?: string;
    error?: string;
}

/**
 * Получить все данные графиков для региона (объединенный запрос)
 */
export const getSectorChartsData = async (
    year: number,
    sector_id: string
): Promise<SectorChartsResponse> => {
    const url = `/form30/sector-charts?year=${year}&sector_id=${sector_id}`;
    
    const response = await fetchData(url, {
        method: "GET",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        }
    }, 2);

    return response.json();
};
